<template>
  <section class="whiteBox">
    <!-- HEAD CREATE COUPON -->
    <div class="content">
      <h1 v-if="! this.$route.params.id">{{$t('createCampaign.title')}}</h1>
      <h1 v-else>{{$t('campaigns.modifyCampaignAction')}}</h1>
    </div>
    <div class="row">
      <div class="formBox accentuate blueSelect">{{$t('createCampaign.multipleCoupons')}}</div>
    </div>
    <div class="row whiteBg">
      <i class="far fa-dot-circle"></i>
      <p class="tips">{{$t('createCampaign.generalDescription')}}</p>
      <div class="separator blueColor"></div>
      <i class="far fa-dot-circle blueColor"></i>
      <p class="tips blueColor">{{$t('createCampaign.associateProduct')}}</p>
    </div>

    <!-- Create the first group of discount (only the first time == listOfGroupsOfDiscounts empty) -->
    <div
      class="content"
      v-if="this.listOfGroupsOfDiscounts.length == 0"
    >
      <p class="accentuate">{{$t('groupOfDiscounts.groupOfDiscountsTitle')}}</p>
      <div class="spacer-10"></div>
      <label>{{$t('groupOfDiscounts.groupOfDiscountsName')}}</label> <span
        class="errorSentence"
        v-if="textFieldRequiredGroupOfDiscountName && isSubmit"
      >* {{$t('error.textFieldRequired')}}</span>
      <div class="demiRow">
        <input
          type="text"
          v-bind:class="{ 'error' : textFieldRequiredGroupOfDiscountName && isSubmit,'mInput' :true}"
          v-model="currentGroupOfDiscounts['name']"
        >
      </div>
      <label>{{$t('createCampaign.totalUse')}}</label>
      <span
        class="errorSentence"
        v-if="textFieldRequiredMaxNumberOfUses && isSubmit"
      >* {{$t('error.textFieldRequired')}}</span>
      <div class="row">
        <div class="dataEndInput">
          <p>{{$t('createCampaign.number')}}</p>
          <input
            type="number"
            v-bind:class="{ 'error' : textFieldRequiredMaxNumberOfUses && isSubmit,'mInput' :true}"
            v-model="currentGroupOfDiscounts['max-number-of-uses']"
          >
        </div>
        <p class="tips">{{$t('createCampaign.totalNumberGroupOfDiscountTips')}}</p>
      </div>
      <div>
        <div class="spacer-10"></div>
        <div class="spacer-10"></div>
        <button @click="addFirstGroupOfDiscountsToList()">{{$t('button.createGroupOfDiscountAndAddDiscounts')}}</button>
      </div>
    </div>

    <!-- Show all group of discounts with discounts associated --->
    <div
      class="content"
      v-else
    >
      <div
        @click="modifyGroupOfDiscounts(groupdisc['id'])"
        v-for="groupdisc in listOfGroupsOfDiscounts"
        :key="groupdisc['id']"
        v-bind:class="{'groupOfDiscountCreated reduced': !groupOfDiscountInEdition(groupdisc.id),'groupOfDiscountCreated selected reduced':  groupOfDiscountInEdition(groupdisc.id)}"
      >
        <p class="title">{{groupdisc.name}} | {{groupdisc["max-number-of-uses"]}} {{$t('campaigns.coupons')}} | {{$t('createCampaign.usable')}} 1 {{$t('createCampaign.number')}} </p>
        <button
          @click="changeCurrentDiscountByDiscountId(disc['id'],groupdisc.id)"
          v-bind:class="{'dashedColorBlue': productInEdition(disc),'dashedCreated':!productInEdition(disc) }"
          v-for="disc in groupdisc['associatedDiscountsList']"
          :key="disc['product-id']"
        >{{getProductById(disc["product-id"]).name}} ( - {{disc['discount-value']}} {{getDiscountType(disc['discount-type'])}} ) | {{getProductById(disc["product-id"])['sales-channel-name']}}</button>
        <p>
          {{$t('associateProduct.youCould')}}
          <a @click="addDiscountToGroupOfDiscount(groupdisc)">{{$t('associateProduct.addNewDiscount')}}</a>
        </p>
      </div>
      <div>
        <span>{{$t('associateProduct.yourCampaignIsReady')}}</span>
        <br>
        <p>
          {{$t('associateProduct.youCould')}}
          <a @click="createCouponsAndAddAnotherGroupOfDiscount()">{{$t('associateProduct.addNewGroupOfDiscount')}}</a>
          {{$t('associateProduct.associateDiscountWithAnotherLimit')}}
        </p>
      </div>
    </div>

    <hr>
    <div class="content">
      <div class="row">
        <button
          v-if="! this.$route.params.id"
          @click="next()"
        >{{$t('button.createTheCampaign')}}</button>
        <button
          v-else
          @click="next()"
        >{{$t('button.modifyTheCampaign')}}</button>
        <button
          @click="$emit('return');$emit('groupsofdiscountupdated', { 'list' :listOfGroupsOfDiscounts, 'index' : groupOfDiscountsDynamicIndex})"
          class="outline"
        >{{$t('button.back')}}</button>
        <a @click="goBack">{{$t('button.cancel')}}</a>
      </div>
    </div>

    <!-- POP UPS -->
    <!-- displayed when creating / updating campaign info through server -->
    <WaitBox
      v-if="showProgressCircleBar"
      :parMessage="this.ProgressBarMessage"
    >
    </WaitBox>
    <ManageDiscount
      v-if="showManageDiscount"
      :parMethod="this.manageDiscountMethod"
      :parDiscount="this.currentDiscount"
      :parGroupOfDiscounts="this.currentGroupOfDiscounts"
      :parDiscountDescriptions="this.discountDescriptions"
      @close="showManageDiscount = false"
      @operationondiscountdone="manageDiscountsAssociatedWithReturnedData"
    ></ManageDiscount>

    <ManageGroupOfDiscountBox
      v-if="showGroupOfDiscounts"
      :parMethod="this.manageGroupOfDiscountsMethod"
      :parGroupOfDiscount="this.currentGroupOfDiscounts"
      @close="showGroupOfDiscounts = false"
      @operationondiscountdone="manageGroupOfDiscountWithReturnedData"
    ></ManageGroupOfDiscountBox>
  </section>
</template>

<script>
import axios from "axios";
import getProducts from "@/mixins/getProducts";
import Campaigns from "@/services/Campaigns";
import GroupsOfDiscounts from "@/services/GroupsOfDiscounts";
import ManageGroupOfDiscountBox from "@/components/campaigns/manageCampaign/ManageGroupOfDiscountBox.vue";
import Discounts from "@/services/Discounts";
import DiscountDetails from "@/services/DiscountDetails";
import ManageDiscount from "@/components/discounts/ManageDiscount";
import getCampaignDetails from "@/mixins/getCampaignDetails";
import WaitBox from "@/mixins/WaitBox";
export default {
  props: ["parCampaign", "parGroupsOfDiscounts", "parDynamicIndex"],
  mixins: [getProducts, getCampaignDetails],
  components: { ManageDiscount, ManageGroupOfDiscountBox, WaitBox },
  data() {
    return {
      ProgressBarMessage: "Action sur la campagne en cours",
      showProgressCircleBar: false,
      currentLang: this.$t("lang.fr.title"),
      manageDiscountMethod: "",
      manageGroupOfDiscountsMethod: "",
      showGroupOfDiscounts: false,
      showManageDiscount: false,
      listOfGroupsOfDiscounts: [],
      currentGroupOfDiscounts: {
        id: 0,
        "campaign-id": 0,
        name: "",
        "max-number-of-uses": 0,
        "max-number-of-uses-per-client": 1,
        "global-code": "",
        archived: false,
        associatedDiscountsList: []
      },
      groupOfDiscountsDynamicIndex: 0,
      discountDynamicIndex: 0,
      currentDiscountIsEditing: false,
      isSubmit: false,
      currentDiscount: {
        "product-id": "",
        "group-of-discounts-id": "",
        "discount-type": 0,
        "discount-value": "",
        "discount-currency": "EUR",
        "discount-details": {}
      },
      discountDescriptions: {}
    };
  },
  computed: {
    textFieldRequiredMaxNumberOfUses: function() {
      return !this.currentGroupOfDiscounts["max-number-of-uses"];
    },
    textFieldRequiredGroupOfDiscountName: function() {
      return !this.currentGroupOfDiscounts["name"];
    },
    discountValueFormat: function() {
      // If not a number
      if (this.currentDiscount["discount-value"] == "") return false;
      //convert to number

      var value = parseFloat(this.currentDiscount["discount-value"]);
      //check percentage
      if (this.currentDiscount["discount-type"] == 0) {
        if (value <= 100 && value >= 0 && Number.isInteger(value)) return true;
        //check currency
      } else {
        if (value >= 0) return true;
      }
      return false;
    }
  },
  beforeMount() {
    this.initDiscountDetails();
  },
  mounted() {
    this.getProducts();
    this.initValues();
  },

  methods: {
    /************  UTILS ************/
    productInEdition(discount) {
      return (
        discount["product-id"] == this.currentDiscount["product-id"] &&
        discount["group-of-discounts-id"] == this.currentGroupOfDiscounts.id
      );
    },
    groupOfDiscountInEdition(id) {
      return id == this.currentGroupOfDiscounts["id"];
    },
    goBack() {
      if (this.parCampaign["status"] == 0)
        this.$router.push({
          name: "allCampaigns",
          params: { campaignType: "active" }
        });
      else
        this.$router.push({
          name: "detailGroupCampaign",
          params: { id: this.$route.params.id }
        });
    },

    getDiscountType(type) {
      if (type == 0) {
        return "%";
      } else if (type == 1) {
        return "€";
      }
    },
    getProductById(productId) {
      var returnValue = this.products.find(x => x["id"] === productId);
      if (!returnValue) return "";
      return returnValue;
    },
    changeLang(data) {
      this.currentLang = data;
    },
    //Init Discount Details to default language
    initDiscountDetails() {
      this.discountDescriptions = {
        Français: {
          lang: this.$t("lang.fr.title"),
          code: this.$t("lang.fr.code"),
          description: "",
          archived: false
        }
      };
      this.changeLang(this.discountDescriptions["Français"].lang);
    },
    //Init Values when loading the page (when modifying campaign)
    initValues() {
      if (
        this.parGroupsOfDiscounts != null &&
        this.parGroupsOfDiscounts.length > 0
      ) {
        this.listOfGroupsOfDiscounts = this.parGroupsOfDiscounts;
        this.groupOfDiscountsDynamicIndex = this.parDynamicIndex;
        this.changeCurrentGroupOfDiscount(this.listOfGroupsOfDiscounts[0].id);
      } else {
        this.currentGroupOfDiscounts["campaign-id"] = this.parCampaign.id;
        GroupsOfDiscounts.get(this.parCampaign.id).then(res => {
          if (res.status == 200) {
            for (let indexGoD = 0; indexGoD < res.data.length; indexGoD++) {
              this.listOfGroupsOfDiscounts.push(res.data[indexGoD]);

              Discounts.get(this.listOfGroupsOfDiscounts[indexGoD].id).then(
                res => {
                  if (res.status == 200) {
                    this.listOfGroupsOfDiscounts[
                      indexGoD
                    ].associatedDiscountsList = [];

                    for (let i = 0; i < res.data.length; i++) {
                      this.listOfGroupsOfDiscounts[
                        indexGoD
                      ].associatedDiscountsList[i] = {
                        id: res.data[i]["id"],
                        "product-id": res.data[i]["product-id"],
                        "group-of-discounts-id": this.listOfGroupsOfDiscounts[
                          indexGoD
                        ].id,
                        "discount-type": res.data[i]["discount-type"],
                        "discount-currency": res.data[i]["discount-currency"],
                        "discount-details": {
                          Français: {
                            lang: this.$t("lang.fr.title"),
                            code: this.$t("lang.fr.code"),
                            description: "",
                            archived: false
                          }
                        }
                      };
                      this.listOfGroupsOfDiscounts[
                        indexGoD
                      ].associatedDiscountsList[i]["discount-value"] =
                        res.data[i]["discount-type"] == 1
                          ? res.data[i]["discount-value"] / 100
                          : res.data[i]["discount-value"];
                      DiscountDetails.get(res.data[i].id).then(res => {
                        if (res.status == 200) {
                          var languages = Object.keys(this.$t("lang"));
                          for (var z = 0; z < languages.length; z++) {
                            var localDiscountDetails = res.data.find(
                              x =>
                                x["language"] ==
                                this.$t("lang")[languages[z]].code
                            );
                            if (
                              localDiscountDetails &&
                              this.listOfGroupsOfDiscounts[indexGoD]
                                .associatedDiscountsList[i]
                            ) {
                              var currentLangTest = this.$t("lang")[
                                languages[z]
                              ];
                              this.listOfGroupsOfDiscounts[
                                indexGoD
                              ].associatedDiscountsList[i]["discount-details"][
                                currentLangTest.title
                              ] = {
                                lang: currentLangTest.title,
                                code: currentLangTest.code,
                                description: localDiscountDetails.description,
                                archived: false
                              };
                            }
                          }
                          if (
                            indexGoD == 0 &&
                            this.listOfGroupsOfDiscounts[indexGoD]
                          ) {
                            this.changeCurrentGroupOfDiscount(
                              this.listOfGroupsOfDiscounts[0].id
                            );
                          }
                        }
                      });
                    }
                  }
                }
              );
            }
          }
        });
      }
    },

    addFirstGroupOfDiscountsToList() {
      this.isSubmit = true;
      // show discount add popup
      if (!this.textFieldRequiredMaxNumberOfUses) {
        this.isSubmit = false;
        this.manageGroupOfDiscountsInList();
        this.addDiscountToGroupOfDiscount(this.currentGroupOfDiscounts);
      }
    },

    //Discount associating
    createCouponsAndAddAnotherGroupOfDiscount() {
      this.currentGroupOfDiscounts = {
        id: 0,
        "campaign-id": 0,
        name: "",
        "max-number-of-uses": 0,
        "max-number-of-uses-per-client": 1,
        "global-code": "",
        archived: false,
        associatedDiscountsList: []
      };
      this.manageGroupOfDiscountsMethod = "add_groupOfDiscount";
      this.showGroupOfDiscounts = true;
      window.scrollTo(0, 0);
    },
    addDiscountToGroupOfDiscount(selectedGroupOfDiscounts) {
      this.currentGroupOfDiscounts = selectedGroupOfDiscounts;
      this.showManageDiscount = true;
      this.manageDiscountMethod = "add_discount";
    },
    manageGroupOfDiscountsInList() {
      //add or modify group of discounts
      var groupOfDIscountIndex = this.listOfGroupsOfDiscounts.findIndex(
        x => x["id"] == this.currentGroupOfDiscounts["id"]
      );
      if (groupOfDIscountIndex != -1) {
        //group of discount found
        this.listOfGroupsOfDiscounts[
          groupOfDIscountIndex
        ] = this.currentGroupOfDiscounts;
      } else {
        this.groupOfDiscountsDynamicIndex++;
        this.currentGroupOfDiscounts["id"] =
          "#" + this.groupOfDiscountsDynamicIndex;
        this.listOfGroupsOfDiscounts.push(this.currentGroupOfDiscounts);
      }
    },

    manageDiscountsAssociatedWithReturnedData(data) {
      this.isSubmit = false;
      if (data.groupOfDiscounts.id) {
        data.discount["group-of-discounts-id"] = data.groupOfDiscounts.id;
        this.currentGroupOfDiscounts = data.groupOfDiscounts;
        this.currentDiscount = data.discount;
        this.discountDescriptions = data.discountDescriptions;
        if(data.discount["product-id"] && !this.products.find(x => x.id == data.discount["product-id"])){
          this.getProducts();
        }
        this.manageGroupOfDiscountsInList();
        this.manageDiscountAssociate();
      }
    },
    manageGroupOfDiscountWithReturnedData(data) {
      if (data.groupOfDiscount) {
        this.currentGroupOfDiscounts = data.groupOfDiscount;
        this.manageGroupOfDiscountsInList();
      }
    },
    manageDiscountAssociate() {
      //add or modify discounts associated
      this.currentDiscount["discount-details"] = this.discountDescriptions;
      var groupOfDIscountIndex = this.listOfGroupsOfDiscounts.findIndex(
        x => x["id"] == this.currentGroupOfDiscounts["id"]
      );
      if (groupOfDIscountIndex != -1) {
        //group of discount found
        if (!this.currentDiscount["id"]) {
          this.discountDynamicIndex++;
          this.currentDiscount["id"] = "#" + this.discountDynamicIndex;
        }
        this.currentDiscount[
          "group-of-discounts-id"
        ] = this.listOfGroupsOfDiscounts[groupOfDIscountIndex].id;
        discountTempIndex = -1;
        if (
          this.listOfGroupsOfDiscounts[groupOfDIscountIndex]
            .associatedDiscountsList
        ) {
          //if discounts associated
          var discountTempIndex = this.listOfGroupsOfDiscounts[
            groupOfDIscountIndex
          ].associatedDiscountsList.findIndex(
            x => x["product-id"] === this.currentDiscount["product-id"]
          );
        } else {
          this.listOfGroupsOfDiscounts[
            groupOfDIscountIndex
          ].associatedDiscountsList = [];
        }
        if (this.currentDiscount["product-id"] && discountTempIndex != -1) {
          //discount and current discount found
          this.listOfGroupsOfDiscounts[
            groupOfDIscountIndex
          ].associatedDiscountsList[discountTempIndex] = this.currentDiscount;
        } else if (this.currentDiscount["product-id"]) {
          this.listOfGroupsOfDiscounts[
            groupOfDIscountIndex
          ].associatedDiscountsList.push(this.currentDiscount);
        }
      }
      this.currentDiscount = {
        "product-id": "",
        "group-of-discounts-id": "",
        "discount-type": 0,
        "discount-value": "",
        "discount-currency": "EUR",
        "discount-details": []
      };
      this.initDiscountDetails();
      this.currentDiscountIsEditing = false;
    },
    //Switch between discounts associated
    changeCurrentDiscountByDiscountId(discountId, groupOfDiscountId) {
      if (groupOfDiscountId) {
        this.changeCurrentGroupOfDiscount(groupOfDiscountId);
      }
      var discountSelected = this.currentGroupOfDiscounts.associatedDiscountsList.find(
        x => x["id"] == discountId
      );
      if (discountSelected) {
        this.changeCurrentGroupOfDiscount(
          discountSelected["group-of-discounts-id"]
        );
        this.currentDiscount = discountSelected;
        this.initDiscountDetails();
        this.currentDiscountIsEditing = true;
        this.discountDescriptions = this.currentDiscount["discount-details"];
        this.changeLang(this.discountDescriptions["Français"].lang);
        this.showManageDiscount = true;
        this.manageDiscountMethod = "modify_discount";
      } else {
        this.currentDiscountIsEditing = false;
        this.initDiscountDetails();
      }
    },
    changeCurrentGroupOfDiscount(groupOfDiscountId) {
      var groupOfDiscountSelected = this.listOfGroupsOfDiscounts.find(
        x => x["id"] == groupOfDiscountId
      );
      if (groupOfDiscountSelected) {
        this.currentGroupOfDiscounts = groupOfDiscountSelected;
      }
      //open pop up change current discount
    },
    modifyGroupOfDiscounts(groupOfDiscountId) {
      this.changeCurrentGroupOfDiscount(groupOfDiscountId);
      if (!this.showManageDiscount) {
        this.showGroupOfDiscounts = true;
        this.manageGroupOfDiscountsMethod = "modify_groupOfDiscount";
      }
    },
    //NEXT PAGE
    next() {
      this.isSubmit = true;
      //display wait
      this.showProgressCircleBar = true;
      if (
        this.listOfGroupsOfDiscounts.length > 0 &&
        this.listOfGroupsOfDiscounts[0].associatedDiscountsList.length > 0
      ) {
        this.addNewGroupOfDiscounts(this.parCampaign.id);
      }
    },
    /******************************************************************************
     *                          Interaction with Server                           *
     * ****************************************************************************/

    finishCampaignUpdate(campaignId) {
      //add all discounts and discount details
      for (var i = 0; i < this.listOfGroupsOfDiscounts.length; i++) {
        this.insertUpdateDiscountsByGroupOfDiscounts(
          this.listOfGroupsOfDiscounts[i]
        );
      }
      //update all GoD
      var promises = [];
      for (var k = 0; k < this.listOfGroupsOfDiscounts.length; k++) {
        if (!isNaN(this.listOfGroupsOfDiscounts[k].id)) {
          delete this.listOfGroupsOfDiscounts[k].associatedDiscountsList;
          promises.push(
            GroupsOfDiscounts.partialUpdate(
              this.listOfGroupsOfDiscounts[k].id,
              this.listOfGroupsOfDiscounts[k]
            ).catch(err => {console.log(err);this.showProgressCircleBar = false;})
          );
        }
      }
      if (promises != null && promises.length != 0) {
        axios.all(promises).then(() => {
          Campaigns.partialUpdate(campaignId, { status: 1 }).then(res => {
            if (res.status == 204) {
              this.$router.push({
                name: "detailGroupCampaign",
                params: { id: campaignId }
              });
            }
          });
        });
      }
    },

    insertUpdateDiscountsByGroupOfDiscounts(groupOfDiscounts) {
      if (groupOfDiscounts.associatedDiscountsList != null) {
        for (
          let i = 0;
          i < groupOfDiscounts.associatedDiscountsList.length;
          i++
        ) {
          if (groupOfDiscounts.associatedDiscountsList[i]["discount-type"] == 1)
            groupOfDiscounts.associatedDiscountsList[i]["discount-value"] =
              groupOfDiscounts.associatedDiscountsList[i]["discount-value"] *
              10 *
              10;
          if (
            isNaN(groupOfDiscounts.associatedDiscountsList[i].id) &&
            groupOfDiscounts.associatedDiscountsList[i].id.includes("#")
          ) {
            this.insertDiscount(
              groupOfDiscounts.id,
              groupOfDiscounts.associatedDiscountsList[i]
            );
          } else {
            this.updateDiscount(
              groupOfDiscounts.associatedDiscountsList[i].id,
              groupOfDiscounts.associatedDiscountsList[i]
            );
          }
        }
      }
    },

    // DISCOUNTS
    // =========
    insertDiscount(groupOfDiscountId, discountObject) {
      delete discountObject.id;
      delete discountObject["group-of-discounts-id"];
      Discounts.add(groupOfDiscountId, discountObject).then(res => {
        if (res.status == 201) {
          let locationSplit = res.headers.location.split("/");
          var newDiscountId = locationSplit[locationSplit.length - 1];
          var languages = Object.keys(discountObject["discount-details"]);
          for (var i = 0; i < languages.length; i++) {
            this.insertDiscountDetails(
              newDiscountId,
              discountObject["discount-details"][languages[i]]
            );
          }
        }
      });
    },
    updateDiscount(discountId, discountObject) {
      Discounts.partialUpdate(discountId, discountObject).then(res => {
        if (res.status == 204) {
          DiscountDetails.get(discountObject["id"]).then(res => {
            var languages = Object.keys(discountObject["discount-details"]);
            if (res.status == 200 && res.data) {
              for (var i = 0; i < languages.length; i++) {
                var tempDiscountDetailsObject = res.data.find(
                  x =>
                    x["language"] ==
                      discountObject["discount-details"][languages[i]].code &&
                    x["discount-id"] == discountObject["id"]
                );
                if (tempDiscountDetailsObject) {
                  this.updateDiscountDetails(
                    tempDiscountDetailsObject["id"],
                    discountObject["discount-details"][languages[i]]
                  );
                } else {
                  this.insertDiscountDetails(
                    discountObject["id"],
                    discountObject["discount-details"][languages[i]]
                  );
                }
              }
            }
            // if no discount detail (empty GET)
            else {
              for (var j = 0; j < languages.length; j++) {
                this.insertDiscountDetails(
                  discountObject["id"],
                  discountObject["discount-details"][languages[j]]
                );
              }
            }
          });
        }
      });
    },

    // DISCOUNT DETAILS
    // ================

    insertDiscountDetails(discountId, discountDetailObject) {
      DiscountDetails.add(discountId, {
        language: discountDetailObject.code,
        description: discountDetailObject.description,
        archived: false
      }).then();
    },
    updateDiscountDetails(discountDetailsId, discountDetailObject) {
      DiscountDetails.partialUpdate(discountDetailsId, {
        language: discountDetailObject.code,
        description: discountDetailObject.description,
        archived: false
      }).then();
    },

    // GROUP OF DISCOUNTS
    // ==================

    //Creates new Groups Of Discounts
    addNewGroupOfDiscounts(campaignId) {
      if (campaignId && this.listOfGroupsOfDiscounts) {
        //get discount for each campaign
        var SQLPromises = [];
        var SQLpromisesListOfGroupsOfDiscountsIndex = [];
        for (var k = 0; k < this.listOfGroupsOfDiscounts.length; k++) {
          if (
            isNaN(this.listOfGroupsOfDiscounts[k].id) &&
            this.listOfGroupsOfDiscounts[k].id.includes("#")
          ) {
            SQLPromises.push(
              GroupsOfDiscounts.add(campaignId, {
                name: this.listOfGroupsOfDiscounts[k]["name"],
                "max-number-of-uses-per-client": 1,
                "max-number-of-uses": 1,
                archived: false
              })
            );
            SQLpromisesListOfGroupsOfDiscountsIndex.push(k);
          }
        }
        var serverResponse = [];
        if (SQLPromises != null && SQLPromises.length != 0) {
          axios.all(SQLPromises).then(results => {
            console.log("traitement SQL");
            console.log(SQLPromises);
            console.log(results);
            results.forEach(response => {
              if (response.status == 201)
                serverResponse.push(response.headers.location);
              else serverResponse.push({});
            });
            for (
              var l = 0;
              l < SQLpromisesListOfGroupsOfDiscountsIndex.length;
              l++
            ) {
              if (serverResponse[l] != {}) {
                console.log("server response " + l);
                console.log(serverResponse[l]);
                //test en forcant erreur
                let locationSplit = serverResponse[l].split("/");
                var newgroupOfDiscountId =
                  locationSplit[locationSplit.length - 1];
                this.listOfGroupsOfDiscounts[
                  SQLpromisesListOfGroupsOfDiscountsIndex[l]
                ].id = newgroupOfDiscountId;
              }
            }
            this.finishCampaignUpdate(campaignId);
          });
        } else {
          this.finishCampaignUpdate(campaignId);
        }
      }
    }
  }
};
</script>
<style scoped>
.groupOfDiscountCreated {
  display: block;
  margin-bottom: 10px;
  border-radius: 4px;
  background: white;
  border: 1px solid black;
  padding: 20px;
  cursor: pointer;
}

.groupOfDiscountCreated.selected {
  border: dashed 1px #2e75d0;
}

.groupOfDiscountCreated.selected > p.title{
    color: #2e75d0;
}

.groupOfDiscountCreated > .title {
  margin-bottom: 10px;
  font-size: x-large;
}

.groupOfDiscountCreated > button {
  margin-bottom: 10px;
}
</style>